import styled from 'styled-components';
import { rem } from 'polished';
import colorItemContainerStyles from '../../styles/colorItemContainerStyles';
import { colorVariantHorizontalSpacingStyles } from '../../styles/colorVarianStyles';

const ColorVariantOuterContainer = styled.div`
    ${colorItemContainerStyles}
    align-items: center;
    border-radius: ${({ theme }) => rem(theme.base.borderRadius.default)};
    box-shadow: ${({ theme, colorVariant }) =>
        colorVariant ? theme.base.boxShadow.elevationDefault : '0 1px 2px rgba(0,0,0,0.125)'};
    display: flex;
    flex-flow: column nowrap;
    min-height: ${({ theme, minHeight }) => minHeight || theme.site.colorVariant.minHeight}px;
    min-width: ${({ theme }) => rem(theme.site.colorVariant.minWidth)};
    opacity: ${({ hasChanged }) => (hasChanged ? 0.5 : 1)};
    position: relative;
    user-select: none;
    transition: opacity 0.3s ease-in-out, width 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    width: 100%;

    ${colorVariantHorizontalSpacingStyles}
`;

export default ColorVariantOuterContainer;
